export default __webpack_public_path__ + "static/media/56_mobile.804189bc.jpg";